module.exports = __webpack_public_path__ + "static/media/declaration-of-independence.d867ff82.jpg";